<template>
  <CheckRbac :permissions="permissions">
    <template #default="{ granted }">
      <slot v-if="granted" />
    </template>
  </CheckRbac>
</template>

<script setup>
import CheckRbac from './CheckRbac.vue';

/**
 * Renders the default slot only when the current user has all required
 * permissions. Nothing is mounted in the DOM when access is not granted.
 */
defineOptions({ name: 'HideRbac' });

defineProps({
  permissions: {
    type: Array,
    default: () => [],
  },
});
</script>
